"use client";

import { useQuery } from "@tanstack/react-query";
import { useSupabaseClient } from "@/components/SupabaseProvider";

/**
 * A project's ready shorts, counted as the results header counts them
 * (status "ready"): the shorts Auto post books. For surfaces that don't load
 * the project's videos, such as the calendar's Auto post menu.
 */
export function useReadyShortCount(folderId: string | undefined): number | undefined {
  const supabase = useSupabaseClient();
  return useQuery({
    queryKey: ["ready-short-count", folderId],
    enabled: Boolean(folderId),
    queryFn: async () => {
      const { count, error } = await supabase.from("videos_v2").select("id", { count: "exact", head: true })
        .eq("folder_id", folderId!).eq("status", "ready");
      if (error) throw error;
      return count ?? 0;
    },
  }).data;
}
